<template>
  <Contract v-if="address.flag == 1" v-bind:contract="address" :isLoading="isLoading"/>
  <Account v-else v-bind:account="address" :isLoading="isLoading"/>
</template>

<script>
import { mapGetters } from 'vuex';
import Account from './account.vue';
import Contract from './contract.vue';

export default {
  name: 'AddressContainer',
  computed: {
    ...mapGetters(['address']),
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {
    '$route.params.address'(newAddress) {
      this.fetchData(newAddress);
    },
    address() {
      this.isLoading = false;
    },
  },
  created() {
    this.fetchData(this.$route.params.address);
  },
  methods: {
    fetchData(address) {
      this.isLoading = true;
      this.$store.dispatch('submitQuery', { query: address, type: 'address' });
    },
  },
  components: {
    Account,
    Contract,
  },
};
</script>
